import React, { useState, useEffect, useRef } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { translate } from 'react-polyglot';
import Button from '../Button';
import Modal from '../Modal';
import Overlay from '../Overlay';
import Stuffer from '../Stuffer';
import TextField from '../TextField';
import Sizer from '../Sizer';
import { isRightToLeftDirection } from '../../util/utils';
import './SearchModal.scss';
import { SearchAutoSuggest } from '../../api';

const SearchModal = ({ t, viewport, onClose, onSubmit }) => {
    const [query, setQuery] = useState('');
    const [searchDropDown, setSearchDropDown] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const timeoutRef = useRef(null);

    useEffect(() => {
        document.getElementById('search-modal-input')?.focus();
    }, []);

    const handleChange = (e) => {
        const searchValue = e.target.value;
        setQuery(searchValue);
        setSearchDropDown(true);

        if (timeoutRef.current) clearTimeout(timeoutRef.current);

        if (searchValue === '') {
            setSearchDropDown(false);
            setSearchResults([]);
        } else {
            timeoutRef.current = setTimeout(() => {
                SearchAutoSuggest.fetchAutoSuggestResults(searchValue)
                    .then((response) => response.json())
                    .then((data) => setSearchResults(data.data))
                    .catch((error) =>
                        console.error('Error fetching search results:', error)
                    );
            }, 500);
        }
    };

    const handleSearchResultSelect = (selectedValue) => {
        onSubmit(
            (selectedValue &&
                selectedValue.target &&
                selectedValue.target.value &&
                selectedValue.target.value) ||
                selectedValue
        );
        setSearchDropDown(false);
    };

    const handleSubmit = () => onSubmit(query);

    const baseClassName = 'pb-search-modal';

    const classes = {
        [baseClassName]: true,
    };

    return (
        <div className={classNames(classes)}>
            <Modal
                background="transparent"
                onClose={onClose}
                overlayTheme="light"
                search
            >
                <form onSubmit={(e) => {e.preventDefault(); handleSubmit()}}>
                <div className={`${baseClassName}__search-box`}>
                    <TextField
                        name="q"
                        label={t('GlobalSearch.title')}
                        size="l"
                        onChange={handleChange}
                        id="search-modal-input"
                        bordered={false}
                        searchInput
                    />
                    {searchDropDown && (
                        <div
                            className={
                                isRightToLeftDirection
                                    ? `${baseClassName}_title-dropdown-rtl`
                                    : `${baseClassName}_title-dropdown`
                            }
                        >
                            {query.length >= 4 && (
                                <Sizer maxHeight="l" scrollY>
                                    {searchResults.map(
                                        (searchResultValue, index) => (
                                            <div
                                                key={index}
                                                className={
                                                    isRightToLeftDirection
                                                        ? `${baseClassName}_search-results-rtl`
                                                        : `${baseClassName}_search-results`
                                                }
                                                onClick={() =>
                                                    handleSearchResultSelect(
                                                        searchResultValue
                                                    )
                                                }
                                            >
                                                {searchResultValue}
                                            </div>
                                        )
                                    )}
                                </Sizer>
                            )}
                        </div>
                    )}
                </div>
                </form>
                <div className={query === '' ? 'searchbutton-disable' : ''}>
                    <Stuffer horizontalSpacing={viewport.medium ? 'xl' : null}>
                        <Button
                            parentClassName={`${baseClassName}__submit`}
                            label={t('SearchModal.submit-label')}
                            onClick={handleSubmit}
                            variant="nav-link-button"
                            fullWidth
                        />
                    </Stuffer>
                </div>
            </Modal>
            <Overlay theme="light" />
        </div>
    );
};

SearchModal.propTypes = {
    viewport: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    onClose: PropTypes.func,
    onSubmit: PropTypes.func,
};

export default translate()(SearchModal);
